import type { FareCode } from "@silversea-ssc/web-fares-fp"
import { FareContent } from "../sanity/sanity-types"

export const fareCodeLabel = (faresContent: FareContent[] | undefined, fareCode: FareCode) => {
    const content = faresContent?.find((x) => x.fareCodes.includes(fareCode))
    return content?.title || fareCode
}
